import { render, staticRenderFns } from "./assistState.vue?vue&type=template&id=2edf89c0"
import script from "./assistState.vue?vue&type=script&lang=js"
export * from "./assistState.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports